import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=74ed138c"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=74ed138c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports